.titleAndTooltipContainer {
    display: flex;
    gap: 4px;
}

.additionalInfo {
    padding-left: 36px;
    padding-bottom: 18px;
    display: flex;
    flex-direction: column;
}

.lastUpdatedInfoContainer {
    display: flex;
    padding-top: 9px;
    padding-bottom: 18px;
}

.lastUpdatedInfo {
    display: flex;
    flex-direction: column;
    padding-right: 36px;
}

.accordionHeaderContainer {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    padding: 5px;
    border-radius: 9px;
    background-color: rgba(5, 60, 89, .06);
}

.accordionContainer {
    display: flex;
    align-items: center;
    padding: 5px;
}

.accordionHeaderTitle {
    flex: 3 1 auto;
    padding-left: 36px;
}

.accordionHeaderEffectiveDate {
    min-width: 200px;
    padding-left: 20px;
}

.accordionHeaderControls {
    min-width: 150px;
}

.accordionHeaderOwner {
    min-width: 250px;
}

.accordionHeaderAction {
    min-width: 150px;
}

.accordionColumnTitle {
    flex: 3 1 auto;
    display: flex;
    align-items: center;
}

.accordionColumnTextContainer {
    display: flex;
    flex-direction: column;
}

.accordionColumnEffectiveDate {
    min-width: 200px;
    padding-left: 20px;
}

.accordionColumnControls {
    min-width: 150px;
}

.accordionColumnOwner {
    min-width: 250px;
}

.accordionColumnAction {
    min-width: 150px;
}

.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}